import { Routes } from '@angular/router';
import { authCanMatch, authCanActivate } from './app/guards/auth.guard';

export const appRoutes: Routes = [
    { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
    { path: 'auth', loadChildren: () => import('@/pages/auth/auth.routes') },
    {
        path: 'public-form/questionaryResponse/preview-success',
        loadComponent: () => import('./app/pages/public-form/pages/success-preview.component').then(m => m.SuccessPreviewComponent)
    },
    {
        path: 'public-form/questionaryResponse/:id',
        loadChildren: () => import('./app/pages/public-form/public-form.routes').then(m => m.PUBLIC_FORM_ROUTES)
    },
    {
        path: '',
        loadComponent: () => import('@/layout/components/app.layout').then(m => m.AppLayout),
        canActivate: [authCanActivate],
        canMatch: [authCanMatch],
        children: [
            { path: '', redirectTo: '/dashboards', pathMatch: 'full' },
            {
                path: 'dashboards',
                data: { breadcrumb: 'Analytics Dashboard' },
                loadChildren: () => import('@/pages/dashboard/dashboard.routes'),
                canActivate: [authCanActivate],
                canMatch: [authCanMatch]
            },
            {
                path: 'uikit',
                data: { breadcrumb: 'UI Kit' },
                loadChildren: () => import('@/pages/uikit/uikit.routes'),
                canMatch: [authCanMatch]
            },
            {
                path: 'utility',
                data: { breadcrumb: 'AI Utility' },
                loadChildren: () => import('@/pages/utility/utility.routes').then(m => m.UTILITY_ROUTES),
                canMatch: [authCanMatch]
            },
            {
                path: 'pages',
                data: { breadcrumb: 'Pages' },
                loadChildren: () => import('@/pages/pages.routes'),
                canMatch: [authCanMatch]
            },
            {
                path: 'apps',
                data: { breadcrumb: 'Apps' },
                loadChildren: () => import('./app/apps/apps.routes'),
                canMatch: [authCanMatch]
            },
            {
                path: 'blocks',
                data: { breadcrumb: 'Prime Blocks' },
                loadChildren: () => import('@/pages/blocks/blocks.routes'),
                canMatch: [authCanMatch]
            },
            {
                path: 'profile',
                data: { breadcrumb: 'Profile' },
                loadComponent: () => import('./app/layout/components/profile/profile.component').then(m => m.ProfileComponent)
            },
            {
                path: 'master',
                data: { breadcrumb: 'Master' },
                loadChildren: () => import('@/pages/master/master.routes').then(r => r.MASTER_ROUTES),
                canMatch: [authCanMatch]
            },
            {
                path: 'masterData',
                data: { breadcrumb: 'Master Data' },
                loadChildren: () => import('@/pages/masterData/master-data.routes').then(r => r.MASTER_DATA_ROUTES),
                canMatch: [authCanMatch]
            },
            {
                path: 'operations',
                data: { breadcrumb: 'Operations' },
                loadChildren: () => import('@/pages/operations/operations.module').then(m => m.OperationsModule),
                canMatch: [authCanMatch]
            },
            {
                path: 'procurement',
                data: { breadcrumb: 'Procurement' },
                loadChildren: () => import('@/pages/procurement/procurement.routes').then(p => p.PROCUREMENT_ROUTES),
                canMatch: [authCanMatch]
            },
            {
                path: 'gps-data',
                data: { breadcrumb: 'GPS Data' },
                loadChildren: () => import('@/pages/gps-data/gps-data.module').then((m) => m.GpsDataModule),
                canMatch: [authCanMatch]
            },
            {
                path: 'mobile-app',
                data: { breadcrumb: 'Mobile App' },
                loadChildren: () => import('@/pages/mobileApp/mobileApp.routes').then(m => m.MOBILE_APP_ROUTES),
                canMatch: [authCanMatch]
            },
            {
                path: 'visibility',
                data: { breadcrumb: 'Visibility' },
                loadChildren: () => import('@/pages/visibility/visibility.routes').then(m => m.VISIBILITY_ROUTES)
            },
            {
                path: 'tracking',
                redirectTo: 'gps-data/tracking',
                pathMatch: 'full'
            },
            {
                path: 'fleet-maintenance',
                data: { breadcrumb: 'Fleet Maintenance' },
                loadChildren: () => import('@/pages/fleet-maintenance/fleet-maintenance.routes').then(m => m.FLEET_MAINTENANCE_ROUTES)
            },
            {
                path: 'ai',
                data: { breadcrumb: 'AI' },
                loadChildren: () => import('@/pages/ai/ai.route').then(m => m.AI_ROUTES)
            },
            {
                path: 'log',
                data: { breadcrumb: 'Log' },
                loadChildren: () => import('@/pages/log/log.route').then(m => m.LOG_ROUTES)
            },
            {
                path: 'inventory',
                data: { breadcrumb: 'Inventory' },
                loadChildren: () => import('@/pages/inventory/inventory.routes').then(m => m.INVENTORY_ROUTES)
            },
            {
                path: 'upload',
                data: { breadcrumb: 'Upload' },
                loadChildren: () => import('@/pages/upload/upload.routes').then((m) => m.UPLOAD_ROUTES)
            },
            {
                path: 'actionable',
                data: { breadcrumb: 'My Actionable' },
                loadChildren: () => import('@/pages/myActionable/actionable.routes').then(m => m.ACTIONABLE_ROUTES)
            },
            {
                path:'order-management',
                data: { breadcrumb: 'Order Management' },
                loadChildren: () => import('@/pages/order-management/order-management.routes').then(m => m.ORDER_MANAGEMENT_ROUTES)
            },
            {
                path: 'standard',
                data: { breadcrumb: 'Standard' },
                loadChildren: () => import('@/pages/standard-api/standard-api.routes').then(m => m.STANDARD_API_ROUTES),
                canMatch: [authCanMatch]
            }
        ]
    },
    {
        path: 'landing',
        loadComponent: () => import('@/pages/landing/landing').then(m => m.Landing)
    },
    {
        path: 'notfound',
        loadComponent: () => import('@/pages/notfound/notfound').then(m => m.Notfound)
    },
    {
        path: 'no-access',
        loadComponent: () => import('@/pages/no-access/no-access').then(m => m.NoAccess)
    },
    { path: '**', redirectTo: '/notfound' }
];
